import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: fit-content;
  max-width: 70%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  overflow: auto;
  .MuiTypography-body1 {
    font-size: 14px;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    left: 15%;
  }
  @media only screen and (max-width: 480px) {
    left: 15%;
  }
`;

export const ButtonConfirm = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1.0")};
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;
export const ButtonCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  height: auto;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  border-radius: 9px;
  margin-top: 1em;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
    };
  },
};

export const IconGuest = styled.img`
  width: 18.33px;
`;
